module.exports = __webpack_public_path__ + "img/still (35).179aaa02.jpg";